var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBricks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: 750,
    height: 620,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 15,
    rx: 15,
    id: "svg_2",
    height: 125,
    width: 219.00001,
    y: 23,
    x: 20,
    stroke: "#4D2425",
    fill: "#894F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 15,
    rx: 15,
    id: "svg_3",
    height: 125,
    width: 219.00001,
    y: 23,
    x: 264,
    stroke: "#4D2425",
    fill: "#894F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 15,
    rx: 15,
    id: "svg_4",
    height: 125,
    width: 219.00001,
    y: 23,
    x: 20,
    stroke: "#4D2425",
    fill: "#894F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 15,
    rx: 15,
    id: "svg_5",
    height: 125,
    width: 219.00001,
    y: 23,
    x: 264,
    stroke: "#4D2425",
    fill: "#894F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 15,
    rx: 15,
    id: "svg_6",
    height: 125,
    width: 219.00001,
    y: 173,
    x: 143,
    stroke: "#4D2425",
    fill: "#894F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 15,
    rx: 15,
    id: "svg_7",
    height: 125,
    width: 219.00001,
    y: 174,
    x: 385,
    stroke: "#4D2425",
    fill: "#894F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 15,
    rx: 15,
    id: "svg_8",
    height: 125,
    width: 219.00001,
    y: 23,
    x: 20,
    stroke: "#4D2425",
    fill: "#894F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 15,
    rx: 15,
    id: "svg_9",
    height: 125,
    width: 219.00001,
    y: 23,
    x: 264,
    stroke: "#4D2425",
    fill: "#894F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 15,
    rx: 15,
    id: "svg_10",
    height: 125,
    width: 219.00001,
    y: 21,
    x: 512,
    stroke: "#4D2425",
    fill: "#894F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 15,
    rx: 15,
    id: "svg_11",
    height: 125,
    width: 219.00001,
    y: 324,
    x: 20,
    stroke: "#4D2425",
    fill: "#894F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 15,
    rx: 15,
    id: "svg_12",
    height: 125,
    width: 219.00001,
    y: 324,
    x: 264,
    stroke: "#4D2425",
    fill: "#894F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 15,
    rx: 15,
    id: "svg_13",
    height: 125,
    width: 219.00001,
    y: 324,
    x: 20,
    stroke: "#4D2425",
    fill: "#894F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 15,
    rx: 15,
    id: "svg_14",
    height: 125,
    width: 219.00001,
    y: 324,
    x: 264,
    stroke: "#4D2425",
    fill: "#894F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 15,
    rx: 15,
    id: "svg_15",
    height: 125,
    width: 219.00001,
    y: 324,
    x: 20,
    stroke: "#4D2425",
    fill: "#894F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 15,
    rx: 15,
    id: "svg_16",
    height: 125,
    width: 219.00001,
    y: 324,
    x: 264,
    stroke: "#4D2425",
    fill: "#894F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 15,
    rx: 15,
    id: "svg_17",
    height: 125,
    width: 219.00001,
    y: 324,
    x: 510,
    stroke: "#4D2425",
    fill: "#894F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 15,
    rx: 15,
    id: "svg_18",
    height: 125,
    width: 219.00001,
    y: 474,
    x: 145,
    stroke: "#4D2425",
    fill: "#894F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 15,
    rx: 15,
    id: "svg_19",
    height: 125,
    width: 219.00001,
    y: 476,
    x: 387,
    stroke: "#4D2425",
    fill: "#894F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 15,
    rx: 15,
    id: "svg_20",
    height: 125,
    width: 98,
    y: 172,
    x: 19,
    stroke: "#4D2425",
    fill: "#894F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 15,
    rx: 15,
    id: "svg_21",
    height: 125,
    width: 98,
    y: 472,
    x: 21,
    stroke: "#4D2425",
    fill: "#894F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 15,
    rx: 15,
    id: "svg_22",
    height: 125,
    width: 98,
    y: 173,
    x: 632,
    stroke: "#4D2425",
    fill: "#894F3F"
  }), /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 15,
    rx: 15,
    id: "svg_23",
    height: 125,
    width: 98,
    y: 476,
    x: 631,
    stroke: "#4D2425",
    fill: "#894F3F"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBricks);
export default __webpack_public_path__ + "static/media/bricks.e8cef354d9f422c518ee0d690a9566ea.svg";
export { ForwardRef as ReactComponent };